import { track } from '$global/utils/track';

export interface TrackDropPageViewAfterOpenInput {
	// Platform-namespaced event name, supplied by the drop page — Editions and
	// Primary each own theirs (see their constants/mixpanel-events.ts).
	event: string;
	dropConfigId: string;
	slug: string;
	// Directus `drop_start_date` as a timestamp in ms. Undefined when the drop
	// config has no start date, in which case the elapsed time is unknowable and
	// is left off the payload rather than guessed at.
	startedAt?: number;
	// Server-synced clock (see createTimeContext), in ms. Never `Date.now()` —
	// a skewed client clock would poison the elapsed time this event exists to
	// measure.
	now: number;
}

export const trackDropPageViewAfterOpen = ({
	event,
	dropConfigId,
	slug,
	startedAt,
	now,
}: TrackDropPageViewAfterOpenInput) => {
	// Clamped at zero: the ticking clock can sit a fraction behind the start date
	// for the earliest arrivals, and a negative "time since open" is not a thing
	// anyone wants to see in a report.
	const secondsSinceOpen =
		startedAt === undefined
			? undefined
			: Math.max(0, Math.round((now - startedAt) / 1000));

	track(event, {
		drop_config_id: dropConfigId,
		slug,
		...(secondsSinceOpen !== undefined && {
			seconds_since_open: secondsSinceOpen,
		}),
	});
};
